import DistrictSettingsQuestions from './DistrictSettingsQuestions';
export default DistrictSettingsQuestions;
